import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircleIcon, PhoneIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { business } from '../data/business';
export function FloatingActions() {
  const {
    t
  } = useLanguage();
  const [showBubble, setShowBubble] = useState(true);
  return <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-3 sm:bottom-6 sm:right-6" data-id="element-131" data-mp="5ecyamrge63q">
      <AnimatePresence data-id="element-132" data-mp="9e5cbezm94gh">
        {showBubble ? <motion.div initial={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex max-w-[15rem] items-start gap-2 rounded-2xl bg-white px-4 py-3 shadow-lift" data-id="element-133" data-mp="9h1bf6n79z6i">
            <div data-id="element-134" data-mp="2l598lwuulb8e">
              <p className="font-display text-xs font-bold text-navy" data-id="element-135" data-mp="2l6tu6wz6pju4">{t(copy.whatsappBubble)}</p>
              <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="text-xs font-semibold text-royal underline" data-id="element-136" data-mp="g45llkb3yj25">
                {business.phone}
              </a>
            </div>
            <button type="button" onClick={() => setShowBubble(false)} aria-label={t(copy.dismissBubble)} className="-mr-1 -mt-1 rounded-md p-1 text-charcoal/40 transition-colors duration-150 ease-out hover:text-charcoal" data-id="element-137" data-mp="2c8wlp4qkp9z">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-138" data-mp="pyp36nd9tkhi" />
            </button>
          </motion.div> : null}
      </AnimatePresence>

      <a href={business.phoneHref} aria-label={`${t(copy.callUs)} ${business.phone}`} className="flex items-center justify-center rounded-full bg-royal p-4 text-white shadow-lift transition-colors duration-150 ease-out hover:bg-navy sm:hidden" data-id="element-139" data-mp="3aq7puj0bpwjs">
        <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-140" data-mp="376h3ps742l0q" />
      </a>

      <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label={t(copy.whatsappUs)} className="flex items-center justify-center rounded-full bg-[#25D366] p-4 text-white shadow-lift transition-transform duration-150 ease-out hover:scale-105" data-id="element-141" data-mp="3c6borf47ggdv">
        <MessageCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-142" data-mp="2oghd30vmgxv7" />
      </a>
    </div>;
}